import { IUpdatedByQuery } from '../interfaces/updated-by.interface';

// @dynamic
export class UpdatedBy {
    id: string;
    firstName: string;
    lastName: string;
    permissions: string[];

    constructor(query: IUpdatedByQuery) {
        this.id = query.id.toString();
        this.firstName = query.first_name;
        this.lastName = query.last_name;
        this.permissions = query.permission;
    }
}
